import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

interface Props {
  readonly title: string;
  readonly message: string;
}

// tr('NO_ACTIVITY_YET_TITLE')
// tr('NO_ACTIVITY_YET_SUBTITLE')

export const EmptyTableView: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactElement => {
  const { title, message, children } = props;

  return (
    <Box sx={styles.container}>
      <Box sx={styles.textBox}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="custom.LightGray">
          {message}
        </Typography>
      </Box>
      {children}
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    gap: 2,
  },
};
